export enum UserMenuButton {
  SETTING= 'SETTING',
  HELP = 'HELP',
  FINASTRA_PAGE = 'FINASTRA_PAGE',
  FINASTRA_VERSION = 'FINASTRA_VERSION',
  LOGOUT = 'LOGOUT'
}
